import React from 'react';

import { hideConfirmModal, showConfirmModal } from 'redux-store/reducers/modal-reducer';

import { getActionByName, getPromptExitAdditionalContent } from 'utils/prompt-exit';
import { sanitizeGenericHtml } from 'utils/sanitize';

export function askUserToConfirmRouteExit(dispatch, next: () => void, onCancel?: () => void): void {
  const prompt = document.querySelector('.js-prompt-exit-page');

  if (prompt && prompt instanceof HTMLElement && prompt.dataset.message) {
    const action = getActionByName(prompt.dataset.action ?? '');
    const additionalContent = getPromptExitAdditionalContent(
      decodeURIComponent(prompt.dataset.additionalContent ?? ''),
      () => {
        dispatch(hideConfirmModal());
        prompt.removeAttribute('class');
        next();
      }
    );

    // ask the user
    dispatch(showConfirmModal({
      additionalContent,
      title: decodeURIComponent(prompt.dataset.title ?? ''),
      message: decodeURIComponent(prompt.dataset.message),
      confirmButtonLabel: decodeURIComponent(prompt.dataset.confirmButtonLabel ?? ''),
      cancelButtonLabel: decodeURIComponent(prompt.dataset.cancelButtonLabel ?? ''),
      confirmButtonColor: decodeURIComponent(prompt.dataset.actionButtonColor ?? ''),
      innerContent: prompt.dataset.innerContent && (
        <div dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(prompt.dataset.innerContent) }} />
      ),
      onProceed: action && (() => {
        dispatch(hideConfirmModal());
        prompt.removeAttribute('class'); // prevent multiple confirm modals in case of redirects
        next();
      }),
      onConfirm: () => { // go to the next page
        dispatch(hideConfirmModal());
        prompt.removeAttribute('class'); // prevent multiple confirm modals in case of redirects

        if (action) {
          action();
        } else {
          next();
        }
      },
      onCancel: () => { // stay on the same page
        dispatch(hideConfirmModal());

        if (onCancel) {
          onCancel();
        }
        // `next()` is not called here to stop middleware chain and to skip state updates
      }
    }));
  } else {
    // go to the next route without asking (default behavior)
    next();
  }
}

export function askUserToConfirmRouteExitPromise(dispatch): Promise<'next' | 'cancel'> {
  return new Promise((resolve) => {
    askUserToConfirmRouteExit(dispatch, () => resolve('next'), () => resolve('cancel'));
  });
}
